const featureExchangeApi = ({ exchange, exchangeAssets, exchangeLimits, exchangeQuotes, }) => ({
    exchange: {
        getBestQuote: exchangeQuotes.getBestQuote,
        getLimits: exchangeLimits.getLimits,
        getPrefilledAmounts: exchangeLimits.getPrefilledAmounts,
        ackExchange: exchange.ackExchange,
        cancelExchange: exchange.cancelExchange,
        exchange: exchange.exchange,
        prepareExchange: exchange.prepareExchange,
        executeExchange: exchange.executeExchange,
        getSupportedFromAssetIds: exchangeAssets.getSupportedFromAssetIds,
        getSupportedToAssetIds: exchangeAssets.getSupportedToAssetIds,
        searchAssets: exchangeAssets.searchAssets,
        isPairSupported: exchangeAssets.isPairSupported,
        isAssetExchangeable: exchangeAssets.isAssetExchangeable,
    },
});
const exchangeDefinition = {
    id: 'exchangeApi',
    type: 'api',
    factory: featureExchangeApi,
    dependencies: ['exchange', 'exchangeAssets', 'exchangeLimits', 'exchangeQuotes'],
};
export default exchangeDefinition;
